import React from 'react';
import { isValidArray } from 'src/Library/Helper';
import useRefs from '../useRefs';
import { FieldHookProps } from 'src/components/common/form/form.types';
import * as uuid from 'uuid';

const useFieldGroup = <RefType = any>({
  defaultNodes,
  onFirstRender,
  requestRerender,
  extraData,
}: {
  defaultNodes: {
    renderComponent: any, // TODO: React.ReactElement?
    renderProps: FieldHookProps,
    // formKey: string,
  }[];
  onFirstRender?: () => Promise<any>;
  requestRerender?: () => void,
  extraData?: any,
}) => {
  const [nodes, setNodes] = React.useState(defaultNodes);
  const refs = useRefs<RefType>(nodes?.length);
  const [renderSwtich, setRenderSwitch] = React.useState(false);
  const [removedNodes, setRemovedNodes] = React.useState([] as number[]);
  const [firstRender, setFirstRender] = React.useState(true);
  const [UID, setUID] = React.useState(uuid());

  React.useEffect(() => {
    // refs.refs.map(ref => console.log({ current: (ref as any)?.current?.field?.value }));
    if (!renderSwtich && !refs.refs.filter(ref => !(ref as any)?.current)?.length && nodes?.length === refs?.refs?.length) {
      setRenderSwitch(true);
      if (firstRender) {
        setFirstRender(false);
        onFirstRender && onFirstRender();
      }
    }
  }, [refs.refs.map(ref => ref?.current)]);

  if (!renderSwtich && !refs?.refs?.filter(ref => !(ref as any)?.current)?.length && nodes?.length === refs?.refs?.length) {
    setRenderSwitch(true);
  }
  if (renderSwtich && nodes?.length !== refs?.refs?.length) {
    setRenderSwitch(false);
  }

  const requestRerenderLocal = () => {
    requestRerender ? requestRerender() : setRenderSwitch(false);;
  };

  React.useEffect(() => {
    // setUID(uuid());
    // refs.setSize(0);
    // if(nodes?.length !== refs?.refs?.length) {
    //   console.log({ len: nodes?.length });
    //   refs.setSize(nodes?.length);
    // }
    // requestRerenderLocal();
  }, [nodes, removedNodes]);

  const union = nodes.map((node, idx) => {
    return !removedNodes.includes(idx) ? {
      Node: node.renderComponent,
      ref: refs?.refs[idx],
      nodeKey: UID + idx.toString(),
    } : null;
  });

  const injectProps = (el: any) => {
    if (!el?.key) return el;
    const intKey = parseInt(el?.key?.replace(UID, ''));
    if (intKey == null) return el;
    const node = nodes[intKey];
    if (/*el?.key &&*/ el.key.includes(UID) && el?.type?.$$typeof === node?.renderComponent?.$$typeof) {
      return React.cloneElement(el, {
        ...node?.renderProps,
        ref: refs?.refs[intKey],
        requestRerender: requestRerenderLocal,
        // formKey: node?.formKey,
      });
    } else {
      return el;
    }
  };

  const injectPropsWrapper = (el: any) => {
    if (isValidArray(el?.props?.children)) {
      return el?.props?.children?.map(child => {
        return injectProps(child);
      });
    } else {
      return injectProps(el?.props?.children);
    }
  };

  const walk = (el: any) => {
    if (isValidArray(el)) {
      return el.map(element => {
        return walk(element);
      });
    } else {
      return el?.props?.children ? React.cloneElement(el, {
        children: walk(injectPropsWrapper(el)),
      }) : el;
    }
  };

  const render = (cb: (fields: typeof union, uid: string) => any /**(React.ReactElement)[]? */) => {
    const cbOut = cb(union, UID);
    const walkout = walk(cbOut);
    return React.createElement(React.Fragment, null, walkout);
  };

  const replaceNodes = (newNodes) => {
    const oldNodesIndices = nodes.reduce((acc, node, idx) => {
      acc.push(idx);
      return acc;
    },[] as number[]);
    setRemovedNodes(oldNodesIndices);
    setNodes([
      ...nodes,
      ...newNodes,
    ]);
  };

  return {
    render,
    refs: refs?.refs?.filter((ref, idx) => !removedNodes.includes(idx)),
    nodes, //: nodes.filter((node, idx) => !removedNodes.includes(idx)),
    setNodes,
    removedNodes,
    replaceNodes,
    setRemovedNodes,
    fieldType: 'group',
    extraData,
    requestRerender: requestRerenderLocal,
  };
};

export default useFieldGroup;
